export default "__VITE_ASSET__Be_zpiF5__"